"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _icons = require("@material-ui/icons");

var _core = require("@material-ui/core");

var _CardMenu = require("./CardMenu");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductCard = function ProductCard(_ref) {
  var children = _ref.children,
      list = _ref.list,
      cardClass = _ref.cardClass,
      image = _ref.image,
      imageTitle = _ref.imageTitle,
      imageHoverText = _ref.imageHoverText,
      imageClass = _ref.imageClass,
      onMediaClick = _ref.onMediaClick,
      contentClass = _ref.contentClass,
      showFavorite = _ref.showFavorite,
      isFavorite = _ref.isFavorite,
      favoriteLocation = _ref.favoriteLocation,
      favoritePosition = _ref.favoritePosition,
      onFavorite = _ref.onFavorite,
      favoriteIconActive = _ref.favoriteIconActive,
      favoriteIconDisabled = _ref.favoriteIconDisabled,
      iconButtonClass = _ref.iconButtonClass,
      showPopoverMenu = _ref.showPopoverMenu,
      menuIcon = _ref.menuIcon,
      menuItems = _ref.menuItems,
      menuAnchorEl = _ref.menuAnchorEl,
      menuHandlerClick = _ref.menuHandlerClick,
      menuHandlerClose = _ref.menuHandlerClose,
      menuIconPosition = _ref.menuIconPosition,
      flag = _ref.flag,
      flagPosition = _ref.flagPosition;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var defaultCardClasses = (0, _styles.useCardStyles)({
    list: list
  });
  var defaultMediaClasses = (0, _styles.useMediaStyles)();
  var wrapperClasses = (0, _styles.useWrapperStyles)();
  var defaultContentClasses = (0, _styles.useContentStyles)({
    list: list
  });
  var actionAreaClasses = (0, _styles.useActionAreaStyle)({
    list: list
  });
  var defaultIconButtonClasses = (0, _styles.useIconButtonStyles)({
    favoritePosition: favoritePosition
  });
  var flagClasses = (0, _styles.useFlagStyles)({
    flagPosition: flagPosition
  });
  var hoverTextClasses = (0, _styles.useHoverTextStyle)();
  var cardStyles = cardClass ? (0, _clsx.default)(defaultCardClasses.root, cardClass.root) : defaultCardClasses.root;
  var mediaStyles = imageClass ? (0, _clsx.default)(defaultMediaClasses.root, imageClass.root) : defaultMediaClasses.root;
  var wrapperStyles = list ? (0, _clsx.default)(wrapperClasses.root, wrapperClasses.list) : (0, _clsx.default)(wrapperClasses.root, wrapperClasses.gallery);
  var contentStyles = contentClass ? (0, _clsx.default)(defaultContentClasses.root, contentClass.root) : defaultContentClasses.root;
  var iconButtonStyles = iconButtonClass ? (0, _clsx.default)(defaultIconButtonClasses.root, iconButtonClass.root) : defaultIconButtonClasses.root;
  var cardListStyle = {
    height: 'auto',
    maxWidth: '100%'
  };
  var cardMediaListStyle = {
    height: 'auto'
  };
  var contentListStyle = {
    margin: 0
  };

  var showFavoriteInImage = function showFavoriteInImage() {
    if (showFavorite && favoriteLocation === 'image') {
      return true;
    }

    return false;
  };

  var showFavoriteInWrapper = function showFavoriteInWrapper() {
    if (showFavorite && favoriteLocation === 'wrapper') {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: cardStyles,
    style: list ? cardListStyle : {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: wrapperStyles
  }, /*#__PURE__*/_react.default.createElement(_core.CardActionArea, {
    className: actionAreaClasses.root
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    alt: imageTitle,
    title: imageTitle,
    className: mediaStyles,
    image: image,
    style: list ? cardMediaListStyle : {},
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onMediaClick
  }), showFavoriteInImage() && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    className: iconButtonStyles,
    "aria-label": isFavorite ? 'Desfavoritar Livro' : 'Favoritar Livro'
  }, isFavorite ? favoriteIconActive : favoriteIconDisabled), flag && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: flagClasses.root
  }, flag), hover && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: hoverTextClasses.root
  }, imageHoverText)), /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: contentStyles,
    style: list ? contentListStyle : {}
  }, children), showFavoriteInWrapper() && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    className: iconButtonStyles
  }, isFavorite ? favoriteIconActive : favoriteIconDisabled), showPopoverMenu && /*#__PURE__*/_react.default.createElement(_CardMenu.CardMenu, {
    menuIcon: menuIcon,
    menuItems: menuItems,
    menuAnchorEl: menuAnchorEl,
    menuHandlerClick: menuHandlerClick,
    menuHandlerClose: menuHandlerClose,
    menuIconPosition: menuIconPosition
  })));
};

exports.ProductCard = ProductCard;
ProductCard.propTypes = {
  // Componentes do conteúdo do card
  children: _propTypes.default.node,
  // Define o formato do Card: Galeria (vertical) ou Lista (horizontal)
  list: _propTypes.default.bool,
  // Objeto com classe "root" para estilização da imagem
  cardClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // URL da Imagem do Card
  image: _propTypes.default.string.isRequired,
  // Texto alternativo e titulo da imagem do Card
  imageTitle: _propTypes.default.string,
  // Texto do hover da imagem do Card
  imageHoverText: _propTypes.default.string,
  // Objeto com classe "root" para estilização da imagem
  imageClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // Função acionada ao clicar na imagem do Card
  onMediaClick: _propTypes.default.func,
  // Objeto com classe "root" para estilização da Wrapper de conteúdo
  contentClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // Define se será exibido o botão de favoritar
  showFavorite: _propTypes.default.bool,
  // Estado que representa se o item é favorito ou não
  isFavorite: _propTypes.default.bool,
  // Define onde o botão de Favorito será renderizado, junto ao container da imagem, ou ao container do card.
  favoriteLocation: _propTypes.default.oneOf(['image', 'wrapper']),
  // Caso o favoriteLocation seja "image", define a direção que o icone de favoritos será renderizado.
  favoritePosition: _propTypes.default.oneOf(['bottomLeft', 'bottomRight', 'topLeft', 'topRight']),
  // Icone do botão de favoritar ativo
  favoriteIconActive: _propTypes.default.node,
  // Icone do botão de favoritar desativado
  favoriteIconDisabled: _propTypes.default.node,
  // Função de callbcak do click do botão de favoritar
  onFavorite: _propTypes.default.func,
  // Objeto com classe "root" para estilização da botão do ícone de favoritar
  iconButtonClass: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  // Define se será exibido o botão com menu de opções em Popover
  showPopoverMenu: _propTypes.default.bool,
  // Icone do botão do menu Popover
  menuIcon: _propTypes.default.node,
  // Posicionamento do icone do menu
  menuIconPosition: _propTypes.default.oneOf(['left', 'right']),
  // Elemento HTML que define a posição do menu Popover
  menuAnchorEl: _propTypes.default.node,
  // Lista com dados dos item do menu Popover
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    click: _propTypes.default.func
  })),
  // Função responsável por abrir o menu Popover
  menuHandlerClick: _propTypes.default.func,
  // Função responsável por fechar o menu Popover
  menuHandlerClose: _propTypes.default.func,
  // Componente de flag com informação adicional para o Card
  flag: _propTypes.default.node,
  // Define a direção que o icone de favoritos será renderizado na imagem
  flagPosition: _propTypes.default.oneOf(['bottomLeft', 'bottomRight', 'topLeft', 'topRight'])
};
ProductCard.defaultProps = {
  children: null,
  list: false,
  cardClass: null,
  imageTitle: '',
  imageClass: null,
  imageHoverText: 'Detalhes',
  onMediaClick: function onMediaClick() {},
  contentClass: null,
  showFavorite: false,
  isFavorite: false,
  favoriteLocation: 'image',
  favoritePosition: 'bottomLeft',
  onFavorite: function onFavorite() {},
  favoriteIconActive: _propTypes.default.instanceOf( /*#__PURE__*/_react.default.createElement(_icons.Favorite, null)),
  favoriteIconDisabled: _propTypes.default.instanceOf( /*#__PURE__*/_react.default.createElement(_icons.FavoriteBorder, null)),
  iconButtonClass: null,
  showPopoverMenu: false,
  menuIcon: _propTypes.default.instanceOf( /*#__PURE__*/_react.default.createElement(_icons.MoreVert, null)),
  menuIconPosition: 'right',
  menuAnchorEl: null,
  menuItems: null,
  menuHandlerClick: function menuHandlerClick() {},
  menuHandlerClose: function menuHandlerClose() {},
  flag: null,
  flagPosition: 'bottomRight'
};